// src/store/reducer.ts
import { createReducer } from "@reduxjs/toolkit";
import type { MyActiveTablesResponse } from "../../api/gameApi";

import {
  // socket / room lifecycle
  roomOpen,
  roomClose,
  roomLoaded,
  roomError,
  // clearError,

  // socket-driven tables
  tablesSet,
  tablesAppend,
  tablesUpdateSeats, // expect payload: { id: number; inc: boolean }
  tablesRemove,

  // HTTP flows
  // fetchMyActiveTablesRequest,
  // fetchMyActiveTablesSuccess,
  // fetchMyActiveTablesFailure,
  // fetchRoomBySlugRequest,
  // fetchRoomBySlugSuccess,
  // fetchRoomBySlugFailure,
  // fetchTableBySlugRequest,
  // fetchTableBySlugSuccess,
  // fetchTableBySlugFailure,
  // fetchSngRegisterCountRequest,
  // fetchSngRegisterCountSuccess,
  // fetchSngRegisterCountFailure,
} from "./roomActions";
import { Room, TableItem } from "../types";

// NOTE: We keep socket tables (TableItem[]) and HTTP "my active tables" (TableLite[]) separate.
export type RoomState = {
  // loading: boolean;
  error?: string;

  // SOCKET lobby tables (rich objects: seats_taken, number_of_seats, locked, owner_id, etc.)
  tables: TableItem[];
  room?: Room;

  // HTTP /tables/my_active_tables (TableLite[])
  // myActiveTables: MyActiveTablesResponse["tables"];
  // tournaments: MyActiveTablesResponse["tournaments"];

  // currentRoom?: Room;
  // currentTable: any | null; // tighten when you have a DTO
  // sngRegisterCount?: number;
};

const initialState: RoomState = {
  // loading: false,

  tables: [], // socket-driven
  // myActiveTables: [], // HTTP-driven
  // tournaments: [],

  // currentRoom: undefined,
  // currentTable: null,
  // sngRegisterCount: undefined,
};

export const roomReducer = createReducer(initialState, (b) => {
  // // ----------- Generic helpers -----------
  // b.addCase(clearError, (s) => {
  //   s.error = undefined;
  // });

  // ----------- Open/Close room -----------
  b.addCase(roomOpen, (s) => {
    // s.loading = true;
    s.error = undefined;
    s.tables = [];
  });
  b.addCase(roomLoaded, (s, a) => {
    s.error = undefined;
    s.room = a.payload;
  });
  b.addCase(roomError, (s, a) => {
    s.error = a.payload;
  });
  b.addCase(roomClose, (s) => {
    s.room = undefined;
    s.tables = []; // clear live lobby tables on leave
    s.error = undefined;
  });

  // ----------- SOCKET: lobby tables (TableItem[]) -----------
  b.addCase(tablesSet, (s, a) => {
    s.tables = a.payload;
  });
  b.addCase(tablesAppend, (s, a) => {
    const incoming = a.payload.filter(
      (t) => !s.tables.find((x) => x.id === t.id)
    );
    s.tables.push(...incoming);
  });
  // b.addCase(tablesAppend, (s, a) => {
  //   s.tables.push(...a.payload);
  // });
  b.addCase(tablesUpdateSeats, (s, a) => {
    // const { id, inc } = a.payload; // expects { id: number; inc: boolean }
    const t = s.tables.find((x) => x.id === a.payload.id);
    if (t)
      t.seats_taken = Math.max(
        0,
        Math.min(t.number_of_seats, t.seats_taken + (a.payload.inc ? 1 : -1))
      );
  });
  b.addCase(tablesRemove, (s, a) => {
    s.tables = s.tables.filter((t) => t.id !== a.payload);
  });

  // ----------- HTTP: /tables/my_active_tables (TableLite[]) + tournaments -----------
  // b.addCase(fetchMyActiveTablesRequest, (s) => {
  //   s.loading = true;
  //   s.error = undefined;
  // });
  // b.addCase(fetchMyActiveTablesSuccess, (s, a) => {
  //   s.loading = false;
  //   s.myActiveTables = a.payload.tables; // TableLite[]
  //   s.tournaments = a.payload.tournaments; // same response
  // });
  // b.addCase(fetchMyActiveTablesFailure, (s, a) => {
  //   s.loading = false;
  //   s.error = a.payload;
  // });

  // // ----------- HTTP: room by slug -----------
  // b.addCase(fetchRoomBySlugRequest, (s) => {
  //   s.loading = true;
  //   s.error = undefined;
  // });
  // b.addCase(fetchRoomBySlugSuccess, (s, a) => {
  //   s.loading = false;
  //   s.currentRoom = a.payload as Room;
  // });
  // b.addCase(fetchRoomBySlugFailure, (s, a) => {
  //   s.loading = false;
  //   s.error = a.payload;
  // });

  // // ----------- HTTP: table by slug -----------
  // b.addCase(fetchTableBySlugRequest, (s) => {
  //   s.loading = true;
  //   s.error = undefined;
  // });
  // b.addCase(fetchTableBySlugSuccess, (s, a) => {
  //   s.loading = false;
  //   s.currentTable = a.payload; // tighten when DTO is available
  // });
  // b.addCase(fetchTableBySlugFailure, (s, a) => {
  //   s.loading = false;
  //   s.error = a.payload;
  // });

  // // ----------- HTTP: SNG register count -----------
  // b.addCase(fetchSngRegisterCountRequest, (s) => {
  //   // no spinner by design; add if needed
  // });
  // b.addCase(fetchSngRegisterCountSuccess, (s, a) => {
  //   s.sngRegisterCount = a.payload;
  // });
  // b.addCase(fetchSngRegisterCountFailure, (s, a) => {
  //   s.error = a.payload;
  // });
});
